import {
  LandingPageThemeId,
  landingPageThemes,
} from '@client/new/common/landingPageThemes';
import { resolvedVisualVersion } from '@client/new/common/landingPageVisualVersion';

export type PageLook = {
  visualVersion: number | null | undefined;
  savedTheme: string | null | undefined;
};

export type PageLookMode = 'none' | 'offer-switch' | 'pick-theme';

export type PageLookEditor =
  | { role: 'creator' }
  | { role: 'staff'; influencerId: number };

const defaultTheme: LandingPageThemeId = 'clean-studio';

export const pageLookEditor = (
  user: {
    isInfluencer: boolean;
    isAdministrator: boolean;
    isModerator: boolean;
    influencerId: unknown;
  },
  influencerId: number,
): PageLookEditor | null => {
  if (user.isInfluencer) {
    return String(user.influencerId) === String(influencerId)
      ? { role: 'creator' }
      : null;
  }
  if (user.isAdministrator || user.isModerator) {
    return { role: 'staff', influencerId };
  }
  return null;
};

export const pageLookMode = (
  editor: PageLookEditor | null,
  visualVersion: PageLook['visualVersion'],
): PageLookMode => {
  if (!editor) return 'none';
  return resolvedVisualVersion(visualVersion) === 2
    ? 'pick-theme'
    : 'offer-switch';
};

export const requestedTheme = (value: unknown): LandingPageThemeId | null =>
  landingPageThemes.find((theme) => theme.id === value)?.id ?? null;

// A creator moved to version 2 by an AM may have no theme stored; the portal renders those with the default theme.
export const themeOrDefault = (
  savedTheme: PageLook['savedTheme'],
): LandingPageThemeId => requestedTheme(savedTheme) ?? defaultTheme;

export const themeToSave = (
  look: PageLook,
  selectedTheme: LandingPageThemeId,
): LandingPageThemeId | null =>
  resolvedVisualVersion(look.visualVersion) === 2 &&
  selectedTheme !== themeOrDefault(look.savedTheme)
    ? selectedTheme
    : null;
